module.exports = __webpack_public_path__ + "img/group_travel_insurance.e5adeffb.jpg";